import React from 'react';
import PageContainer from '../../../../common/components/PageContainer';
import styles from './styles.module.scss';

const FormContainer = ({children}) => {

  return (
    <PageContainer>
      <div className={styles.formContainer}>
        {children}
      </div>
    </PageContainer>
  )
};

export default FormContainer;
